import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { GetSmsCampaignListView } from "../Features/smscampaignlist/Smscampaiglistnview";
import { GetallSmsCampaignListReport } from "../Features/reports/Smscampaignlistreport";
import { UpdateSmsCampaignsStatus } from "../Features/smscampaignlist/smscampaignlist";
import { AddSmsCampaignsListRetry } from "../Features/reports/Smscampaignlistreport";
import { RootState, AppDispatch } from "../Appstore/store";
import { formatDate } from "../helper";
import { setIsLoading } from "../Features/loadingSlice";
import { toast } from "sonner";
import { MdClear } from "react-icons/md";
import { BiExport } from "react-icons/bi";
import { GetallSmsCampaignReportDawnlaod } from "../Features/Smscampaignreports/Smscampaignreportdawnload";
import HelpText from "./HelpText";

export interface SmsCampaignListView {
  id?: number;
  sms_campaign_id?: number;
  name?: string;
  message?: string;
  status?: number;
  schedule_time: string;
  retries: number;
  retry_minutes: number;
  xls_file: string;
  xls_file_name: string;
  numbers_count: number;
  number_to_be_processed: number;
  failed_reason: string;
  createdAt: string;
  updatedAt: string;
  campaign_name: string;
}

export interface SmsCampaignListRecord {
  id?: number;
  receiver_number: string;
  status?: number;
  createdAt: string;
  sms_gateway: {
    name: string;
    id?: number;
    gateway_id?: number;
  };
  sms_gateways_number: {
    gateway_number: string;
  };
  length: number;
}

const STATUS = {
  PENDING: 1,
  RUNNING: 2,
  STOPPED: 3,
  COMPLETED: 4,
  CANCELED: 5,
  FAILED: 6,
};

function Viewsmscampaignlist() {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [limit, setLimit] = useState(10);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { id }: any = useParams();
  const [isExporting, setIsExporting] = useState(false);
  const [smsGatewayName, setsmsGatewayName] = useState("");
  const [gatewayName, setGatewayName] = useState(0);
  const [gatewayNumber, setGatewayNumber] = useState("");
  const [receiverNumber, setReceiverNumber] = useState("");
  const [status, setStatus] = useState("");
  const [retryStatus, setretryStatus] = useState("");
  const [attempt, setAttempt] = useState("");

  const { smscampaignlistviewsdata } = useSelector(
    (state: RootState) => state.smscampaignlistview
  );
  const record: SmsCampaignListView | any = smscampaignlistviewsdata[0];

  const { smscampaignlistreportdata, info, loading, error } = useSelector(
    (state: RootState) => state.smscampaignlistreport
  );
  const recordreport: SmsCampaignListRecord | any =
    smscampaignlistreportdata || [];

  useEffect(() => {
    if (id) {
      dispatch(setIsLoading(true));
      dispatch(GetSmsCampaignListView(id))
        // dispatch(GetallSmsCampaignListReport(id))
        .unwrap()
        .catch((err) => {
          console.error("Error fetching sms campaign list view:", err);
        })
        .finally(() => {
          setTimeout(() => dispatch(setIsLoading(false)), 500);
        });
    }
  }, [id, dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(
        GetallSmsCampaignListReport({
          id: id,
          sms_gateway_name: smsGatewayName,
          sms_gateway: gatewayName,
          gateway_number: gatewayNumber,
          receiver_number: receiverNumber,
          status: status ? parseInt(status, 10) : undefined,
          retry_status: retryStatus ? parseInt(retryStatus, 10) : undefined,
          attempt: attempt ? parseInt(attempt, 10) : undefined,
          limit: limit,
          page: currentPage,
        })
      );
      setIsLoading(true);
    }, 500);
    return () => clearTimeout(timer);
  }, [
    smsGatewayName,
    dispatch,
    gatewayName,
    gatewayNumber,
    receiverNumber,
    status,
    retryStatus,
    attempt,
    currentPage,
    limit,
    id,
  ]);

  const navigatetobackpage = () => {
    navigate(-1);
  };

  const handlestatus = (newStatus: number) => {
    dispatch(UpdateSmsCampaignsStatus({ id, status: newStatus }))
      .unwrap()
      .then(() => {
        console.log(`Status updated to status`);
      })
      .catch((err) => {
        console.error("Error updating campaign status:", err);
      });
  };
  const handlePageChange = (page: number) => {
    if (page > 0 && page <= (info?.total_page || 1)) {
      setCurrentPage(page);
    }
  };

  const handleRetry = async (retrydata: any) => {
    const resp: any = await dispatch(AddSmsCampaignsListRetry(retrydata));
    dispatch(setIsLoading(true));
    if (resp?.payload?.status === "success")
      toast.success(resp?.payload?.message || "");
    else toast.error(resp?.payload?.message || "");
    setTimeout(() => {
      dispatch(setIsLoading(false));
    }, 500);
    dispatch(
      GetallSmsCampaignListReport({
        id: id,
        sms_gateway_name: smsGatewayName,
        sms_gateway: gatewayName,
        gateway_number: gatewayNumber,
        receiver_number: receiverNumber,
        status: status ? parseInt(status, 10) : undefined,
        retry_status: retryStatus ? parseInt(retryStatus, 10) : undefined,
        attempt: attempt ? parseInt(attempt, 10) : undefined,
        limit: limit,
        page: currentPage,
      })
    );
  };

  const handleClearSearchFilter = () => {
    setsmsGatewayName("");
    setGatewayName(0);
    setGatewayNumber("");
    setReceiverNumber("");
    setStatus("");
    setretryStatus("");
    setAttempt("");
    setCurrentPage(1);
  };

  const handleDownload = () => {
    setIsExporting(true);
    dispatch(
      GetallSmsCampaignReportDawnlaod({
        id: id,
        sms_gateway_name: smsGatewayName,
        sms_gateway: gatewayName,
        receiver_number: receiverNumber,
        status: status ? parseInt(status, 10) : undefined,
        retry_status: retryStatus ? parseInt(retryStatus, 10) : undefined,
        attempt: attempt ? parseInt(attempt, 10) : undefined,
        limit: limit,
        page: currentPage,
      })
    )
      .then((response: any) => {
        if (
          response.meta.requestStatus === "fulfilled" &&
          response.payload instanceof Blob
        ) {
          const blob = response.payload;

          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `Sms-Campaign-Report_${new Date().toISOString()}.xlsx`;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      })
      .finally(() => {
        setTimeout(() => {
          setIsExporting(false);
        }, 500);
      });
  };

  if (error) {
    <div>No found data</div>;
  }

  return (
    <>
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content">
            <div className="container-fluid">
              <div className="card mt-4 shadow-sm border rounded">
                <div className="card-header bg-white p-3 d-flex justify-content-md-between">
                  <h2 className="w-100 mb-md-0 fs-3">View Sms Campaign List</h2>
                  <div className="d-flex align-items-center ">
                    <button
                      className={`btn btn-warning me-2 ${
                        record?.status === 1 ? "d-block disabled" : "d-none"
                      }`}
                    >
                      Pending
                    </button>
                    <button
                      onClick={() => handlestatus(2)}
                      className={`btn btn-success me-2 ${
                        record?.status === 3 ? "d-block" : "d-none"
                      }`}
                    >
                      Start
                    </button>
                    <button
                      onClick={() => handlestatus(3)}
                      className={`btn btn-danger me-2 ${
                        record?.status === 2 ? "d-block" : "d-none"
                      }`}
                    >
                      Stop
                    </button>
                    <button
                      onClick={() => handlestatus(5)}
                      className={`btn btn-danger me-2 ${
                        record?.status === 2 ||
                        record?.status === 3 ||
                        record?.status === 5
                          ? "d-block"
                          : "d-none"
                      }`}
                    >
                      Canceled
                    </button>
                    <button
                      className={`btn btn-success me-2 ${
                        record?.status === 4 ? "d-block disabled" : "d-none"
                      }`}
                    >
                      Completed
                    </button>
                    <button
                      className={`btn btn-danger me-2 ${
                        record?.status === 6 ? "d-block disabled" : "d-none"
                      }`}
                    >
                      Failed
                    </button>
                    <button
                      style={{ minWidth: 150 }}
                      className={`btn btn-warning fw-bold me-2 ${
                        record?.status === 7 || record?.status === 8
                          ? "d-block disabled"
                          : "d-none"
                      }`}
                    >
                      {record?.status === 7
                        ? "Retry Pending"
                        : record?.status === 8
                        ? "Retry Running"
                        : ""}
                    </button>

                    <Link to={""} className="text-decoration-none">
                      <button
                        onClick={navigatetobackpage}
                        className="btn btn-info text-white d-flex align-items-center fw-semibold"
                      >
                        <IoMdArrowRoundBack /> Back
                      </button>
                    </Link>
                  </div>
                </div>

                <div className="card-body px-0 py-0">
                  <div className="table-responsive">
                    <table className="table mb-0 table-bordered">
                      <tbody>
                        {!record || record.length === 0 ? (
                          <tr>
                            <td colSpan={7} height={50}>
                              <div className="text-center">
                                <p className="mb-0 fs-5 fw-semibold">
                                  No data found
                                </p>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          <>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Campaign Name
                              </th>
                              <td className="p-3">
                                {record?.campaign_name || "-"}
                              </td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                List Name
                              </th>
                              <td className="p-3">{record?.name || "-"}</td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Message
                              </th>
                              <td className="p-3">{record?.message || "-"}</td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Status
                              </th>
                              <td className="p-3">
                                {record?.status === STATUS.PENDING
                                  ? "Pending"
                                  : record?.status === STATUS.RUNNING
                                  ? "Running"
                                  : record?.status === STATUS.STOPPED
                                  ? "Stopped"
                                  : record?.status === STATUS.COMPLETED
                                  ? "Completed"
                                  : record?.status === STATUS.CANCELED
                                  ? "Canceled"
                                  : record?.status === 7
                                  ? "Retry Pending"
                                  : record?.status === STATUS.CANCELED
                                  ? "Retry Running"
                                  : "Failed"}
                              </td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Schedule Time
                              </th>
                              <td className="p-3">
                                {formatDate(record?.schedule_time) || "-"}
                              </td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Retries
                              </th>
                              <td className="p-3">{record?.retries || "-"}</td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Retry Minutes
                              </th>
                              <td className="p-3">
                                {record?.retry_minutes || "-"}
                              </td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Xls-File
                              </th>
                              <td className="p-3">{record?.xls_file || "-"}</td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Numbers Count
                              </th>
                              <td className="p-3">
                                {record?.numbers_count || "-"}
                              </td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Failed Reasons
                              </th>
                              <td className="p-3">
                                {record?.failed_reason || "-"}
                              </td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Created At
                              </th>
                              <td className="p-3">
                                {formatDate(record?.createdAt || "-")}
                              </td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Updated At
                              </th>
                              <td className="p-3">
                                {formatDate(record?.updatedAt || "-")}
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>

                    <div className="card mt-4 rounded-0 border-start-0 border-end-0">
                      <div className="card-header bg-white p-3 pt-4 d-flex flex-wrap gap-2">
                        <h2 className="mb-0 fs-4 flex-grow-1">
                          Number To be Processed
                        </h2>
                        <div className="d-flex gap-2">
                          <button
                            onClick={handleDownload}
                            className="btn btn-success"
                            disabled={isExporting}
                            style={{ minWidth: 125 }}
                          >
                            <BiExport className="fs-5 me-2" />
                            {isExporting ? "Exporting..." : `Export `}
                          </button>
                          <button
                            onClick={handleClearSearchFilter}
                            className="btn btn-secondary"
                            style={{ minWidth: 125 }}
                          >
                            <MdClear className="fs-5" />
                            Clear Filter
                          </button>
                        </div>
                      </div>
                      <div className="card-body border-start-0 border-end-0 p-0">
                        <>
                          <div className="table-responsive">
                            <table className="table table-hover table-bordered text-nowrap">
                              <thead>
                                <tr>
                                  <th className="ps-3 sr-no">SR No</th>
                                  <th>Sms Gateway Name</th>
                                  <th>Gateway Name</th>
                                  <th>From Number</th>
                                  <th>To Number</th>
                                  <th
                                    className="text-center"
                                    style={{ minWidth: 151 }}
                                  >
                                    Status
                                  </th>
                                  <th
                                    className="text-center"
                                    style={{ width: 151 }}
                                  >
                                    Attempt
                                  </th>
                                  <th
                                    className="text-center"
                                    style={{ minWidth: 130 }}
                                  >
                                    Error Code
                                  </th>
                                  <th className="text-center">Error Message</th>
                                  <th
                                    className="text-center"
                                    style={{ minWidth: 151 }}
                                  >
                                    Retry Status
                                  </th>
                                  <th
                                    className="text-center"
                                    style={{ minWidth: 170 }}
                                  >
                                    Retry At
                                  </th>
                                  <th
                                    className="text-center"
                                    style={{ minWidth: 130 }}
                                  >
                                    Retry Error Code
                                  </th>
                                  <th className="text-center">
                                    Retry Error Message
                                  </th>
                                  <th className="text-center createdat">
                                    Created At
                                  </th>
                                  <th
                                    className="action text-center"
                                    style={{ minWidth: 200 }}
                                  >
                                    Actions
                                  </th>
                                </tr>
                                <tr>
                                  <th className="ps-3"></th>
                                  <th>
                                    <input
                                      type="text"
                                      placeholder="Search Sms Gateway Name"
                                      onChange={(e) =>
                                        setsmsGatewayName(e.target.value.trim())
                                      }
                                      value={smsGatewayName}
                                      className="form-control"
                                    />
                                  </th>
                                  <th>
                                    <select
                                      onChange={(e: any) =>
                                        setGatewayName(e.target.value)
                                      }
                                      className="form-control"
                                      value={gatewayName}
                                    >
                                      <option value="">All Gateways</option>
                                      <option value="1">Twilio</option>
                                      <option value="2">Telnyx</option>
                                    </select>
                                  </th>

                                  <th>
                                    <input
                                      type="text"
                                      placeholder="Search Gateway Number"
                                      onChange={(e) =>
                                        setGatewayNumber(e.target.value.trim())
                                      }
                                      value={gatewayNumber}
                                      className="form-control"
                                    />
                                  </th>
                                  <th>
                                    <input
                                      type="text"
                                      placeholder="Search Receiver Number"
                                      onChange={(e) =>
                                        setReceiverNumber(e.target.value.trim())
                                      }
                                      value={receiverNumber}
                                      className="form-control"
                                    />
                                  </th>
                                  <th>
                                    <select
                                      onChange={(e) =>
                                        setStatus(e.target.value)
                                      }
                                      className="form-control"
                                      value={status}
                                    >
                                      <option value="">All Status</option>
                                      <option value="0">Pending</option>
                                      <option value="1">Sent</option>
                                      <option value="2">Delivered</option>
                                      <option value="3">Undelivered</option>
                                      <option value="4">Failed</option>
                                      <option value="5">
                                        Delivery Unknown
                                      </option>
                                      <option value="6">
                                        Delivery Unconfirmed
                                      </option>
                                      <option value="7">Unknown Gateway</option>
                                    </select>
                                  </th>

                                  <th>
                                    <input
                                      type="text"
                                      placeholder="Search Attempt"
                                      onChange={(e) =>
                                        setAttempt(e.target.value.trim())
                                      }
                                      value={attempt}
                                      className="form-control"
                                    />
                                  </th>
                                  <th></th>
                                  <th></th>
                                  <th>
                                    <select
                                      onChange={(e) =>
                                        setretryStatus(e.target.value)
                                      }
                                      className="form-control"
                                      value={retryStatus}
                                    >
                                      <option value="">All Retry Status</option>
                                      <option value="0">Pending</option>
                                      <option value="1">Sent</option>
                                      <option value="2">Delivered</option>
                                      <option value="3">Undelivered</option>
                                      <option value="4">Failed</option>
                                      <option value="5">
                                        Delivery Unknown
                                      </option>
                                      <option value="6">
                                        Delivery Unconfirmed
                                      </option>
                                      <option value="7">Unknown Gateway</option>
                                    </select>
                                  </th>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                </tr>
                              </thead>

                              <tbody>
                                {loading ? (
                                  <tr>
                                    <td colSpan={15} height={100}>
                                      <div className="text-center">
                                        <div className="loader"></div>
                                      </div>
                                    </td>
                                  </tr>
                                ) : !recordreport ||
                                  recordreport.length === 0 ? (
                                  <tr>
                                    <td colSpan={15} height={50}>
                                      <div className="text-center">
                                        <p className="mb-0 fs-5 fw-semibold">
                                          No data found
                                        </p>
                                      </div>
                                    </td>
                                  </tr>
                                ) : error?.length === 0 ? (
                                  <tr>
                                    <td colSpan={15} height={50}>
                                      <div className="text-center">
                                        <p className="mb-0 fs-5 fw-semibold">
                                          No data found
                                        </p>
                                      </div>
                                    </td>
                                  </tr>
                                ) : (
                                  recordreport.map(
                                    (item: any, index: number) => (
                                      <tr key={item.id}>
                                        <td className="ps-3">
                                          {(currentPage - 1) * limit +
                                            index +
                                            1}
                                        </td>
                                        <td>{item.sms_gateway?.name || "-"}</td>
                                        <td>
                                          {item.sms_gateway?.gateway_id === 1
                                            ? "Twilio"
                                            : "Telnyx"}
                                        </td>
                                        <td>
                                          {item.sms_gateways_number
                                            ?.gateway_number || "-"}
                                        </td>
                                        <td>{item.receiver_number}</td>
                                        <td
                                          className={`text-center ${
                                            item?.status === 0
                                              ? "text-warning fw-bold"
                                              : item?.status === 1
                                              ? "text-success fw-bold"
                                              : item?.status === 2
                                              ? "text-success fw-bold"
                                              : item?.status === 3
                                              ? "text-danger fw-bold"
                                              : item?.status === 4
                                              ? "text-danger fw-bold"
                                              : item?.status === 5
                                              ? "text-info fw-bold"
                                              : item?.status === 6
                                              ? "text-info fw-bold"
                                              : item?.status === 7
                                              ? "text-secondary fw-bold"
                                              : "text-muted"
                                          }`}
                                        >
                                          {item.status === 0
                                            ? "Pending"
                                            : item.status === 1
                                            ? "Sent"
                                            : item.status === 2
                                            ? "Delivered"
                                            : item.status === 3
                                            ? "Undelivered"
                                            : item.status === 4
                                            ? "Failed"
                                            : item.status === 5
                                            ? "Delivery Unknown"
                                            : item.status === 6
                                            ? "Delivery Unconfirmed"
                                            : item.status === 7
                                            ? "Unknown Gateway"
                                            : " - "}
                                        </td>

                                        <td className="text-center">
                                          {item.attempt || "-"}
                                        </td>

                                        <td className="text-center">
                                          {item.error_code || "-"}
                                        </td>

                                        <td className="text-center">
                                          {item.error_message || "-"}
                                        </td>

                                        <td
                                          className={`text-center ${
                                            item?.retry_status === 0
                                              ? "text-warning fw-bold"
                                              : item?.retry_status === 1
                                              ? "text-success fw-bold"
                                              : item?.retry_status === 2
                                              ? "text-success fw-bold"
                                              : item?.retry_status === 3
                                              ? "text-danger fw-bold"
                                              : item?.retry_status === 4
                                              ? "text-danger fw-bold"
                                              : item?.retry_status === 5
                                              ? "text-info fw-bold"
                                              : item?.retry_status === 6
                                              ? "text-info fw-bold"
                                              : item?.retry_status === 7
                                              ? "text-secondary fw-bold"
                                              : "text-muted"
                                          }`}
                                        >
                                          {item.retry_status === 0
                                            ? "Pending"
                                            : item.retry_status === 1
                                            ? "Sent"
                                            : item.retry_status === 2
                                            ? "Delivered"
                                            : item.retry_status === 3
                                            ? "Undelivered"
                                            : item.retry_status === 4
                                            ? "Failed"
                                            : item.retry_status === 5
                                            ? "Delivery Unknown"
                                            : item.retry_status === 6
                                            ? "Delivery Unconfirmed"
                                            : item.retry_status === 7
                                            ? "Unknown Gateway"
                                            : " - "}
                                        </td>

                                        <td className="text-center">
                                          {formatDate(item.retryAt) || "-"}
                                        </td>

                                        <td className="text-center">
                                          {item.retry_error_code || "-"}
                                        </td>
                                        <td className="text-center">
                                          {item.retry_error_message || "-"}
                                        </td>
                                        <td className="text-center">
                                          {formatDate(item.createdAt) || "-"}
                                        </td>

                                        <td className="text-center">
                                          {[3, 4, 5, 6].includes(item.status) &&
                                          (item?.retry_status === null ||
                                            [3, 4, 5, 6].includes(
                                              item.retry_status
                                            )) &&
                                          record?.retries > item?.attempt ? (
                                            <>
                                              <i
                                                data-tooltip-id={
                                                  "Resend_SMS_Btn_" + index
                                                }
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  handleRetry({
                                                    id: item.id,
                                                    sms_campaign_list_id:
                                                      item.sms_campaign_list_id,
                                                  })
                                                }
                                                className="fa-solid fa-rotate-right ms-1 bg-transparent border-0 text-success fs-5"
                                              ></i>
                                              <HelpText
                                                id={"Resend_SMS_Btn_" + index}
                                                content="Resend SMS"
                                              />
                                            </>
                                          ) : (
                                            "-"
                                          )}
                                        </td>
                                      </tr>
                                    )
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>

                          {recordreport?.length === 0 ? (
                            <div></div>
                          ) : (
                            <div className="pagination d-flex justify-content-center align-items-center my-4">
                              <button
                                onClick={() =>
                                  handlePageChange(currentPage - 1)
                                }
                                disabled={currentPage === 1}
                                className="btn border rounded-end-0 text-secondary me-1"
                              >
                                Previous
                              </button>
                              {info?.total_page &&
                                Array.from(
                                  { length: info.total_page },
                                  (_, index) => (
                                    <button
                                      key={index + 1}
                                      onClick={() =>
                                        handlePageChange(index + 1)
                                      }
                                      className={`btn border rounded-0 me-1 ${
                                        currentPage === index + 1
                                          ? "btn-primary"
                                          : "btn-outline-secondary"
                                      }`}
                                    >
                                      {index + 1}
                                    </button>
                                  )
                                )}
                              <button
                                onClick={() =>
                                  handlePageChange(currentPage + 1)
                                }
                                disabled={
                                  currentPage === (info?.total_page || 1)
                                }
                                className="btn border rounded-start-0 text-secondary"
                              >
                                Next
                              </button>
                            </div>
                          )}
                        </>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default Viewsmscampaignlist;
